import { useState } from 'react';
import Dialog from '@/dashboard/components/Dialog/index';
import ExtendPausePolicyView from '@/dashboard/components/Products/policyCard/dialogs/extendPause/index';
import UnPausePolicyView from '@/dashboard/components/Products/policyCard/dialogs/unPausePolicy';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { BanIcon, CalendarIcon, ChevronDownIcon, ChevronUpIcon, ClockIcon, PauseIcon } from '@heroicons/react/outline';
import { Box, Button, Typography } from '@mui/material';

interface TimeInfoProps {
  policy: PolicyModel;
  showPauseBtn?: boolean;
  title?: string;
  list: any[];
}

const TimeInfo = (props: TimeInfoProps) => {
  const { policy, showPauseBtn, title = 'Current period', list } = props;
  const [showUnPauseDialog, setShowUnPauseDialog] = useState(false);
  const [showExtendPauseDialog, setShowExtendPauseDialog] = useState(false);

  return (
    <Box className="flex w-full justify-between px-4 py-3">
      <Box className="flex w-0 flex-1 flex-col">
        <Typography className="font-bold" variant="subtitle2">
          {title}
        </Typography>
        <Box className="flex flex-col">
          {(list || []).map((item) => (
            <Box key={item.title} className="mt-1 flex flex-row items-center">
              <Box className="flex flex-row items-center">
                <PauseIcon className="w-4" />
                <Typography className="ml-1" variant="subtitle2">
                  {item.total_days <= 1 ? item.total_days + 'day' : item.total_days + 'days'}
                </Typography>
              </Box>
              <Box className="ml-5 flex flex-row items-center">
                <CalendarIcon className="w-4" />
                <Typography className="ml-2" variant="subtitle2">
                  {item.dateStr}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      {showPauseBtn && (
        <>
          <Box className="flex flex-row items-center">
            <Button className="font-bold" variant="text" onClick={() => setShowExtendPauseDialog(true)}>
              Extend pause
            </Button>
            <Button className="font-bold" variant="text" onClick={() => setShowUnPauseDialog(true)}>
              Unpause pause
            </Button>
          </Box>
          {/* unpause dialog */}
          {showUnPauseDialog && (
            <Dialog close={() => setShowUnPauseDialog(false)} width="540px">
              <UnPausePolicyView className="mt-5" policy={policy} close={() => setShowUnPauseDialog(false)} />
            </Dialog>
          )}
          {/* extend pause dialog */}
          {showExtendPauseDialog && (
            <Dialog close={() => setShowExtendPauseDialog(false)} width="630px">
              <ExtendPausePolicyView className="mt-5" policy={policy} close={() => setShowExtendPauseDialog(false)} />
            </Dialog>
          )}
        </>
      )}
    </Box>
  );
};

export default TimeInfo;
